import { render, staticRenderFns } from "./TProgressBar.vue?vue&type=template&id=65a5e59b"
import script from "./TProgressBar.vue?vue&type=script&lang=js"
export * from "./TProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports